<template>
  <div>
    <ArticleList
      v-if="isListPage"
      :categoryId="pid"
      :pageTitle="pname"
      layout="image"
      detailPath="/qualification/qualitydetail"
      :sidebar="subCates"
    />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Qualification',
  data() {
    return {
      pid: 0,
      pname: '',
      subCates: []
    }
  },
  computed: {
    isListPage() {
      return this.$route.path === '/qualification'
    }
  },
  watch: {
    $route: {
      handler(newval) {
        if (newval.path === '/qualification') {
          // 用 Number() 归一化：URL 里的 pid 是字符串，字符串 "0" 是真值，
          // 会让下面的 if (!this.pid) 判断失效，兜底逻辑永远进不去
          this.pid = Number(newval.query.pid) || 0
          this.pname = newval.query.pname
          this.loadSubCates()
          if (!this.pid) this.fetchDefaultPid()
        }
      },
      deep: true
    }
  },
  created() {
    this.pname = this.$route.query.pname
    // 同上：字符串 "0" 会被当成有效分类，这里统一转成数字 0 触发兜底
    this.pid = Number(this.$route.query.pid) || 0
    this.loadSubCates()
    if (!this.pid) this.fetchDefaultPid()
  },
  methods: {
    // 拉取当前顶级分类下的子分类（只取 is_menu=1 的菜单项），供左侧导航
    // 与 Latestbroadcast / SalesDepartmentUKbranch 完全一致的取法
    loadSubCates() {
      this.$api.home.getnavList({ lang: 'zn' }).then(res => {
        let cat = res && res.data && res.data.category
        if (!Array.isArray(cat)) {
          cat = Array.isArray(res.data) ? res.data : Object.values((res && res.data) || {})
        }
        if (!Array.isArray(cat) || !this.pid) return
        this.subCates = cat
          .filter(c => Number(c.pid) === Number(this.pid) && Number(c.is_menu) === 1)
          .map(c => ({ id: c.id, name: c.name }))
      }).catch(() => {})
    },
    // URL 没传 pid 时的兜底：优先按顶级栏目的**名称关键字**动态解析，
    // 解析不到（接口失败 / 栏目改名）再退到硬编码 id。
    // ⚠️ 不要改成按 type 匹配：线上「新闻动态」和「产品中心」的 type 都是 list，会认错人；
    //    原先 typeMap 里写的 '/latestbroadcast': 'table' 本身就是错的（实为 list），
    //    而且那段代码排在 hardPid 之后，永远走不到，属于死代码，已删。
    async fetchDefaultPid() {
      const rules = {
        '/latestbroadcast': { keyword: '新闻', hardPid: 3, fallbackName: '新闻动态' },
        '/salesdepartmentukbranch': { keyword: '产品', hardPid: 11, fallbackName: '产品中心' },
        '/qualification': { keyword: '简介', hardPid: 1, fallbackName: '公司简介' }
      }
      const rule = rules[this.$route.path]
      if (!rule) return
      let pid = 0
      let name = ''
      try {
        const res = await this.$api.home.getnavList({ lang: 'zn' })
        let cat = res && res.data && res.data.category
        if (!Array.isArray(cat)) {
          cat = Array.isArray(res.data) ? res.data : Object.values((res && res.data) || {})
        }
        const top = cat
          .filter(c => Number(c.pid) === 0)
          .find(c => (c.name || '').indexOf(rule.keyword) > -1)
        if (top) {
          pid = Number(top.id) || 0
          name = top.name
        }
      } catch (e) { /* 接口失败 → 用硬编码兜底 */ }
      this.pid = pid || rule.hardPid
      if (!this.pname) this.pname = name || rule.fallbackName
      this.loadSubCates()
    }
  }
}
</script>
